// File: /src/components/KanbanColumn.js

import React from 'react';
import { useDroppable } from '@dnd-kit/core';

const KanbanColumn = ({
	id,
	title,
	color,
	count,
	totalValueLabel = 'R$ 0,00',
	averageLeadTimeLabel = 'Sem dados',
	children,
}) => {
	const { setNodeRef, isOver } = useDroppable({
		id: id,
	});

	return (
		<div
			ref={setNodeRef}
			className={`kanban-column ${isOver ? 'kanban-column-over' : ''}`}
		>
			<div className="kanban-column-header" style={{ borderTopColor: color }}>
				<h3>{title}</h3>
				<span className="kanban-column-count" style={{ backgroundColor: color }}>
					{count}
				</span>
			</div>
			<div className="kanban-column-summary">
				<div>
					<span className="kanban-summary-label">Valor total:</span>
					<strong>{totalValueLabel}</strong>
				</div>
				<div>
					<span className="kanban-summary-label">Lead médio:</span>
					<strong>{averageLeadTimeLabel}</strong>
				</div>
			</div>
			<div className="kanban-column-content">{children}</div>
		</div>
	);
};

export default KanbanColumn;
